var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2 8.72V12.08C11.2 14.88 10.08 16 7.28 16H3.92C1.12 16 0 14.88 0 12.08V8.72C0 5.92 1.12 4.8 3.92 4.8H7.28C10.08 4.8 11.2 5.92 11.2 8.72Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.08 0H8.72004C6.25359 0 5.09684 0.875272 4.85585 2.99121C4.80543 3.43388 5.17204 3.8 5.61757 3.8H7.28005C10.64 3.8 12.2 5.36 12.2 8.72V10.3825C12.2 10.828 12.5662 11.1946 13.0088 11.1442C15.1248 10.9032 16 9.74648 16 7.28V3.92C16 1.12 14.88 0 12.08 0Z",
    fill: "#BBBBBB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.586c13fee3c3ead18dfa7be11674acc1.svg";
export { ForwardRef as ReactComponent };